import axios from "axios";

const apiClient = axios.create({
	baseURL:
		process.env.REACT_APP_API_BASE_URL || "https://casestudy.xprssurvey.com",
		// process.env.REACT_APP_API_BASE_URL || "https://localhost:7115",
	headers: {
		"Content-Type": "application/json",
	},
});

//  Request Interceptor — attach token automatically
apiClient.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("authToken");
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

//  Response Interceptor — handle expired/unauthorized tokens globally
apiClient.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response) {
			const { status } = error.response;
			if (status === 401 || status === 403) {
				console.warn(
					"Session expired or unauthorized access. Redirecting to login..."
				);

				// Clear all stored data
				localStorage.removeItem("authToken");
				localStorage.removeItem("userID");
				localStorage.removeItem("userRole");
				localStorage.removeItem("lastLogin");

				// Redirect to login page
				window.location.href = "/";
			}
		}
		return Promise.reject(error);
	}
);

export default apiClient;
